(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/common"), require("ionic-angular"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/common", "ionic-angular"], factory);
	else if(typeof exports === 'object')
		exports["ionic-audiobar"] = factory(require("@angular/core"), require("@angular/common"), require("ionic-angular"));
	else
		root["ionic-audiobar"] = factory(root["@angular/core"], root["@angular/common"], root["ionic-angular"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_72__, __WEBPACK_EXTERNAL_MODULE_73__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition